import { Env } from '@loca/mfe-vue3'
import { createI18n } from 'vue-i18n'
import enUS from './en-US'
import zhCN from './zh-CN'

const i18n = createI18n({
  legacy: false, // 是否允许 setup 中使用 t
  locale: Env.getLanguage() || 'zh-CN',
  messages: {
    'en-US': enUS,
    'zh-CN': zhCN
  }
})

export const t = i18n.global.t

export default i18n
